import styled from 'styled-components'

export const Container = styled.div`
  align-items: center;
  border: 1px solid #E0E0E0;
  border-radius: 8px;
  display: flex;
  gap: 8px;
  padding: 8px 48px 8px 8px;
`

export const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  background-color: #FCF8EF;
  border: 2px solid #E0E0E0;
  border-radius: 4px;
  min-height: 16px;
  min-width: 16px;

  &:checked {
    background-color: #62C1D0;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  }
`

export const Label = styled.label`
  line-height: 24px;
`
